/*eslint complexity: ["error", 33]*/
/*eslint max-lines-per-function: ["error", 200]*/
import React, { useState, useEffect } from 'react';
import { Form, Modal, Button, Card } from 'react-bootstrap';

import { GetPaymentDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { FormControlWithClipboard } from '../../../common/components/FormControlWithClipboard';
import FormRow from '../../../app/components/FormRow';

import { paymentStatusMapper } from './Payments';

interface PaymentEditorProps {
  payment?: GetPaymentDto | null;
  show: boolean;
  onHide: () => void;
  onSave?: (payment: GetPaymentDto) => Promise<void>;
}

export const PaymentEditor: React.FC<PaymentEditorProps> = ({
  payment,
  show,
  onHide,
  onSave,
}) => {
  const [issuedChecked, setIssuedChecked] = useState(false);

  useEffect(() => {
    if (show && payment) {
      setIssuedChecked(payment.isSellDocumentIssued ?? false);
    }
  }, [show, payment]);

  const handleCheckboxChange = (checked: boolean) => {
    setIssuedChecked(checked);
    if (payment) {
      payment.isSellDocumentIssued = checked;
    }
  };

  const handleSave = async () => {
    if (payment && onSave) {
      await onSave(payment);
    }
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Edycja płatności nr {payment?.sysNumber}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Card className="mb-3">
          <Card.Header>Informacje o płatności</Card.Header>
          <Card.Body>
            <Form className="d-grid gap-3">
              {payment?.visit?.surname && payment?.visit?.firstname && (
                <FormRow controlId="visitPerson" label="Pacjent">
                  <Form.Control
                    type="text"
                    value={`${payment.visit.firstname} ${payment.visit.surname}`}
                    disabled
                  />
                </FormRow>
              )}
              {payment?.amount && (
                <FormRow controlId="amount" label="Kwota">
                  <Form.Control
                    type="text"
                    value={`${payment.amount} ${payment.currency}`}
                    disabled
                  />
                </FormRow>
              )}
              {payment?.status && (
                <FormRow controlId="status" label="Status">
                  <Form.Control
                    type="text"
                    value={paymentStatusMapper(payment.status)}
                    disabled
                  />
                </FormRow>
              )}
              {(payment?.gatewayName || payment?.gatewayId) && (
                <FormRow controlId="gatewayName" label="Sposób płatności">
                  <Form.Control
                    type="text"
                    value={payment.gatewayName || payment.gatewayId || ''}
                    disabled
                  />
                </FormRow>
              )}
            </Form>
          </Card.Body>
        </Card>

        <Card className="mb-2">
          <Card.Header>Dokument sprzedaży</Card.Header>
          <Card.Body>
            <Form className="d-grid gap-3">
              {payment?.visit?.sellDocumentType && (
                <FormRow controlId="documentType" label="Typ dokumentu">
                  <Form.Control
                    type="text"
                    value={payment.visit.sellDocumentType}
                    disabled
                  />
                </FormRow>
              )}
              <FormRow controlId="documentIssued" label="Wystawiono dokument">
                <Form.Check
                  type="checkbox"
                  checked={issuedChecked}
                  onChange={e => handleCheckboxChange(e.target.checked)}
                />
              </FormRow>
              {payment?.visit?.invoiceName && (
                <FormRow controlId="invoiceName" label="Nazwa">
                  <FormControlWithClipboard
                    type="text"
                    value={payment.visit.invoiceName}
                    disabled
                  />
                </FormRow>
              )}
              {payment?.visit?.invoiceAddress && (
                <FormRow controlId="invoiceAddress" label="Adres">
                  <FormControlWithClipboard
                    type="text"
                    value={payment.visit.invoiceAddress}
                    disabled
                  />
                </FormRow>
              )}
              {payment?.visit?.invoiceNip && (
                <FormRow controlId="invoiceNip" label="NIP">
                  <FormControlWithClipboard
                    type="text"
                    value={payment.visit.invoiceNip}
                    disabled
                  />
                </FormRow>
              )}
              {payment?.visit?.mail && (
                <FormRow controlId="invoiceEmail" label="E-mail">
                  <FormControlWithClipboard
                    type="text"
                    value={payment.visit.mail}
                    disabled
                  />
                </FormRow>
              )}
            </Form>
          </Card.Body>
        </Card>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Zamknij
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Zapisz
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
